import { AiOutlineProduct } from "react-icons/ai";
import { CiMobile1, CiMoneyCheck1, CiShoppingCart, CiUser } from "react-icons/ci";
import { IoSettingsOutline } from "react-icons/io5";
import { RiHome6Line } from "react-icons/ri";
import { TbMoneybag } from "react-icons/tb";
import { TbTruckDelivery } from "react-icons/tb";
import { UserRole } from "../entity/User";
import { BiBell, BiSupport } from "react-icons/bi";

export const VRoutes = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  VERIFY_EMAIL: "/verify-email",
  PROFILE: "/profile",
  SETTINGS: "/settings",
  NOT_FOUND: "/not-found",
  UNAUTHORIZED: "/unauthorized",
  STORES: "/stores",
  USERS: "/users",
  DELIVERY_COLLECTIONS: "/delivery/collections/",
  DELIVERY_MANAGER: "/delivery/manager",
  DELIVERY_ADD_COLLECTION_TO_ACTION: "/delivery/add-collection-to-action/",
  OPERATIONS: "/operations",
  PRODUCTS: "/products",
  ORDERS: "/orders",
  STORE_DELIVERY: "/store/delivery",
  STORE_TEAM: "/store/team/",
  STORE_TEAM_MEMBER: "/store/team/member/",
  PAYMENT: "/payment",
  PAYMENT_MANAGER: "/payment/manager",
  NOTIFICATION_MANAGER: "/notification/manager",
  MOBILE_APP_MANAGER: "/mobile-app/manager",
  SUPPORT_BY_CHAT: "/supportbychat",
  SUPPORT_BY_CHAT_MANAGER: "/support-by-chat-manager",
};

/**
 * Menu items Store Dashboard
 */
export const MenuItems = [
  {
    path: VRoutes.DASHBOARD,
    icon: RiHome6Line,
    label: "dashboard",
    role: [
      UserRole.ADMIN,
      UserRole.STORE_ADMIN,
      UserRole.SUBADMIN,
      UserRole.STORE_EDITOR,
      UserRole.STORE_CONFIRMER,
    ],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.OPERATIONS,
    icon: TbMoneybag,
    label: "operations",
    role: [UserRole.ADMIN, UserRole.STORE_ADMIN, UserRole.SUBADMIN],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.PRODUCTS,
    icon: AiOutlineProduct,
    label: "products",
    role: [
      UserRole.ADMIN,
      UserRole.STORE_ADMIN,
      UserRole.SUBADMIN,
      UserRole.STORE_EDITOR,
      UserRole.STORE_CONFIRMER,
    ],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.ORDERS,
    icon: CiShoppingCart,
    label: "orders",
    role: [
      UserRole.ADMIN,
      UserRole.STORE_ADMIN,
      UserRole.SUBADMIN,
      UserRole.STORE_EDITOR,
      UserRole.STORE_CONFIRMER,
    ],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.STORE_DELIVERY,
    icon: TbTruckDelivery,
    label: "delivery-companies",
    role: [
      UserRole.ADMIN,
      UserRole.STORE_ADMIN,
      UserRole.SUBADMIN,
      UserRole.STORE_EDITOR,
      UserRole.STORE_CONFIRMER,
    ],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.SETTINGS,
    icon: IoSettingsOutline,
    label: "settings",
    role: [UserRole.ADMIN, UserRole.STORE_ADMIN, UserRole.SUBADMIN],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.STORE_TEAM,
    icon: CiUser,
    label: "team",
    role: [UserRole.ADMIN, UserRole.STORE_ADMIN, UserRole.SUBADMIN],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.PAYMENT,
    icon: CiMoneyCheck1,
    label: "payment",
    role: [UserRole.ADMIN, UserRole.STORE_ADMIN, UserRole.SUBADMIN],
  },
];

/**
 * Menu items Manager Dashboard
 */
export const MenuItemsManager = [
  { path: VRoutes.DASHBOARD, icon: RiHome6Line, label: "dashboard" },
  {
    path: VRoutes.DASHBOARD + VRoutes.STORES,
    icon: TbMoneybag,
    label: "stores",
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.USERS,
    icon: CiUser,
    label: "users",
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.DELIVERY_MANAGER,
    icon: TbTruckDelivery,
    label: "delivery-companies",
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.PAYMENT_MANAGER,
    icon: CiMoneyCheck1,
    label: "paymentManager",
    role: [UserRole.ADMIN, UserRole.SUBADMIN],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.NOTIFICATION_MANAGER,
    icon: BiBell,
    label: "notifications",
    role: [UserRole.ADMIN, UserRole.SUBADMIN],
  },
  {
    path: VRoutes.DASHBOARD + VRoutes.MOBILE_APP_MANAGER,
    icon: CiMobile1,
    label: "mobileApp",
    role: [UserRole.ADMIN, UserRole.SUBADMIN],
  },

  {
    path: VRoutes.DASHBOARD + VRoutes.SUPPORT_BY_CHAT_MANAGER,
    icon: BiSupport,
    label: "support",
    role: [UserRole.ADMIN, UserRole.SUBADMIN],
  },
];
